/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * PHRMPC.Manning.Web.API | v1
 * OpenAPI spec version: 1.0.0
 */
import { z as zod } from 'zod';

export const mcpSiteAssignmentDtoBranchIdRegExpTwo = new RegExp('^-?(?:0|[1-9]\\d*)$');


export const McpSiteAssignmentDto = zod.object({
  "id": zod.string().uuid().optional(),
  "monthlyCoveragePlanId": zod.string().uuid().optional(),
  "date": zod.coerce.date().optional(),
  "branchId": zod.union([zod.number(),zod.string().regex(mcpSiteAssignmentDtoBranchIdRegExpTwo)]).nullish(),
  "branchName": zod.string().nullish(),
  "fromSchedule": zod.string().time({}).nullish(),
  "toSchedule": zod.string().time({}).nullish(),
  "isDeleted": zod.boolean().optional()
});

export type McpSiteAssignmentDto = zod.input<typeof McpSiteAssignmentDto>;
export type McpSiteAssignmentDtoOutput = zod.output<typeof McpSiteAssignmentDto>;
